  class PromoCodeAddProduct extends HTMLElement {
    constructor() {
      super();
      this.status = { loading: false };
    }

    connectedCallback() {
      this.vaiantID = this.dataset.variantId;
      this.isAvailable = this.dataset.isAvailable === 'true';
      this.initEvents();
    }

    initEvents() {
      if (this.isAvailable && this.vaiantID) {
        this.addEventListener('click', () => this.submitForm());
      }
    }

  

    submitForm() {
      if (this.status.loading) return;

      if (!this.vaiantID) {
        this.handleError('No variant selector found');
        return;
      }

      const variantId = this.vaiantID;

      this.status.loading = true;
      this.classList.add('btn--loading');

      const bodyData = new FormData();
      bodyData.append('id', variantId);
      bodyData.append('quantity', 1);

      fetch(window.theme?.routes?.cartAdd || '/cart/add.js', {
        method: 'POST',
        body: bodyData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then((res) => res.json())
        .then((data) => {
          this.classList.remove('btn--loading');
          this.status.loading = false;

          if (data.status === 422) {
            this.handleError(data.description || 'Product could not be added');
          } else {
            this.handleSuccess(data);
          }
        })
        .catch((err) => {
          this.submitBtn.classList.remove('btn--loading');
          this.status.loading = false;
          this.handleError(err.message || 'Network error');
        });
    }

    handleError(message) {
      console.log(`Error: ${message}`);
    }

    handleSuccess(product) {
      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', { detail: product })
      );
      this.closePanel();
    }
  }

  customElements.define('promo-code-add-product', PromoCodeAddProduct);
